import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PulldownComponent } from './pulldown.component';

@NgModule({
  declarations: [PulldownComponent],
  exports: [PulldownComponent],
  imports: [CommonModule],
})
export class PulldownModule {}
